import { useTranslation } from 'react-i18next';

import { FLASH_PAY_BOT_URL } from '../../helpers/settings';
import ButtonEx from '../controls/ButtonEx';
import styles from './styles.module.scss';

export const FlashPayBanner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: t('flash-pay-banner.title') }}></div>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: t('flash-pay-banner.description') }}></div>
      <img src={'/ico/flash-pay-banner-bg.webp'} alt="FlashPay" className={styles.bg} />
      <div className={styles.buttonContainer}>
        <img src={'/ico/logos/flash_pay.svg'} alt="FlashPay" className={styles.logo} />
        <ButtonEx
          caption={`${t('flash-pay-banner.button')}`}
          img={
            <img
              src={'/ico/logos/telegram.svg'}
              alt="Telegram"
              className={styles.telegramIcon}
            />
          }
          className={styles.button}
          onClick={() => {
            window.open(FLASH_PAY_BOT_URL, '_blank');
          }}
        />
      </div>
    </div>
  );
};
